<template>
  <div class='massLoss-list'>
    <div class='nav'>
      <el-form :model='searchForm' label-width='110px' :inline='true'
               class='demo-form-inline flex1' ref='searchForm'>
        <!--        <el-form-item label='年份：'>
                  <el-date-picker
                    v-model='searchForm.year'
                    type='year'
                    placeholder='选择年'>
                  </el-date-picker>
                </el-form-item>-->
        <el-form-item label='台账月：'>
          <el-input v-model='searchForm.standingBookMonth' size='mini'
                    placeholder='请输入台账月'></el-input>
        </el-form-item>
        <el-form-item label='委托商：'>
          <el-input v-model='searchForm.consignorName' size='mini'
                    placeholder='请输入委托商名称'></el-input>
        </el-form-item>
        <el-form-item label='供应商：'>
          <el-input v-model='searchForm.supplierName' size='mini' placeholder='请输入供应商名称'></el-input>
        </el-form-item>

        <el-form-item>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
          <el-button size='small' class='searchBtn' @click='openSummary'>汇总表</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
        <span @click='exportData'>导出数据</span>
      </el-col>
    </el-row>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          v-loading='tableLoading'
          :data='tableData'
          style='width: 100%'
          border
          :header-cell-style='headerCellStyle'
          :span-method='objectSpanMethod'
        >
          <el-table-column prop='standingBookMonth' label='台账月' align='center' min-width='100px' />
          <el-table-column label='收入端' align='center' min-width='100px'>
            <el-table-column prop='consignorName' label='委托商' align='center' min-width='80px' />
            <el-table-column prop='departurePlace' label='起运地' align='center' min-width='100px' />
            <el-table-column prop='departurePort' label='起运港' align='center' min-width='100px' />
            <el-table-column prop='arrivePort' label='交车港' align='center' min-width='100px' />
            <el-table-column prop='arrivePlace' label='交车地' align='center' min-width='100px' />
            <el-table-column prop='transType' label='运输方式' align='center' min-width='100px'>
              <template slot-scope='scope'>
                {{ scope.row.transType === 1 ? '公路' : scope.row.transType === 2 ? '水路' : '水陆联运' }}
              </template>
            </el-table-column>
            <el-table-column prop='srRate' label='运费税率' align='center' min-width='100px' />
            <el-table-column prop='taxSrPrice' label='运费总金额' align='center' min-width='100px' />
            <el-table-column prop='zxRate' label='装卸费税率' align='center' min-width='100px' />
            <el-table-column prop='taxZxPrice' label='装卸费总金额' align='center' min-width='100px' />
          </el-table-column>
          <el-table-column label='成本端' align='center' min-width='100px'>
            <el-table-column prop='supplierName' label='供应商' align='center' min-width='100px' />
            <el-table-column prop='type' label='费用类型' align='center' min-width='100px'>
              <template slot-scope='scope'>
                {{ getType(scope.row.type) }}
              </template>
            </el-table-column>
            <el-table-column prop='zcRate' label='税率' align='center' min-width='100px' />
            <el-table-column prop='taxZcPrice' label='总金额' align='center' min-width='100px' />
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='searchForm.page'
          :page-size='searchForm.rows'
        />
      </div>
    </div>

    <account-summary ref='summaryRef' />
  </div>
</template>

<script>
  import { getPageList } from '@/service/account';
  import { getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';
  import AccountSummary from '../components/summary';

  export default {
    name: 'financeAccount',
    components: { AccountSummary },
    data() {
      return {
        searchForm: {
          // year: new Date(),
          standingBookMonth: '',
          summaryId: '',
          consignorName: '',
          supplierName: '',
          submitType: 0,
          page: 1,
          rows: 10,
        },
        defaultSearchForm: {},
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
        total: 0,
      };
    },
    mounted() {
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      // this.searchBtn();
    },
    methods: {
      openSummary() {
        this.$refs.summaryRef.dialogOpen(0);
      },
      getType(type) {
        switch (type) {
          case 1:
            return '公路运费';
          case 2:
            return '水路运费';
          case 3:
            return '装船费';
          case 4:
            return '卸船费';
          case 5:
            return '过驳费';
          case 6:
            return '转船费';
          case 7:
            return '堆存费';
          case 8:
            return '提车费';
          default:
            return '--';
        }
      },
      // 查询
      searchBtn() {
        this.searchForm.page = 1;
        this.getTableData();
      },
      // 重置
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
      },
      // 获取表格数据
      async getTableData() {
        this.tableLoading = true;
        const data = await getPageList(this.searchForm);
        this.tableLoading = false;
        this.tableData = data.data.records;
        this.total = data.data.total;
      },
      contractSizeChange(row) {
        this.searchForm.rows = row;
        this.searchForm.page = 1;
        this.getTableData();
      },
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getTableData();
      },
      // 合并相同列
      objectSpanMethod({
                         row,
                         column,
                         rowIndex,
                         columnIndex,
                       }) {
        // data ：需要修改的列数和列的属性 第一列从0开始
        const data = [
          {
            columnIndex: 0,
            value: 'standingBookMonth',
          },
          {
            columnIndex: 1,
            value: 'consignorName',
          },
          {
            columnIndex: 2,
            value: 'departurePlace',
          },
          {
            columnIndex: 3,
            value: 'departurePort',
          },
          {
            columnIndex: 4,
            value: 'arrivePort',
          },
          {
            columnIndex: 5,
            value: 'arrivePlace',
          },
          {
            columnIndex: 6,
            value: 'transType',
          },
          {
            columnIndex: 7,
            value: 'srRate',
          },
          {
            columnIndex: 8,
            value: 'taxSrPrice',
          },
          {
            columnIndex: 9,
            value: 'zxRate',
          },
          {
            columnIndex: 10,
            value: 'taxZxPrice',
          },
        ];
        for (let index = 0; index < data.length; index++) {
          if (columnIndex === data[index].columnIndex) {
              const _row = this.filterData(this.tableData, data[index].value)[rowIndex];
              const _col = _row > 0 ? 1 : 0;
              return {
                rowspan: _row,
                colspan: _col,
              };
          }
        }
      },
      // 根据是否有相同数据返回一个如[2,0,3,0,0]格式的数组(公共的)
      filterData(arr, value, consignorNameIndex) {
        let spanOneArr = [];
        let concatOne = 0;
        arr.forEach((item, index) => {
          if (index === 0) {
            spanOneArr.push(1);
          } else {
            if (item['consignorName'] !== arr[index - 1]['consignorName']) {
              spanOneArr.push(1);
              concatOne = index;
            } else if (item[value] === arr[index - 1][value]) {
              spanOneArr[concatOne] += 1;
              spanOneArr.push(0);
            } else {
              spanOneArr.push(1);
              concatOne = index;
            }
          }
        });
        return spanOneArr;
      },
      // 导出数据
      exportData() {
        // let token = getSessionStore('token');
        // window.location.href = `${baseUrl}/platform/settlement/accountCollect/exportXls?access_token=${token}&submitType=0&standingBookMonth=${this.searchForm.standingBookMonth}&consignorName=${this.searchForm.consignorName}&supplierName=${this.searchForm.supplierName}`;
        window.exportExcelGet('/platform/settlement/accountCollect/exportXls', `submitType=0&standingBookMonth=${this.searchForm.standingBookMonth}&consignorName=${this.searchForm.consignorName}&supplierName=${this.searchForm.supplierName}`)
      },
    },
  };
</script>

<style lang='scss' scoped>
  .massLoss-list {
    /*width:100%;*/
    padding: 20px 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/
    .nav {
      /*width:100%;*/
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    ::v-deep .detail {
      .el-form-item {
        margin-bottom: 2px;

        .el-form-item__label {
          /*color: #060606;*/
          font-weight: 700;
        }
      }

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;
      padding: 10px 0 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(249, 166, 6);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }


        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding-right: 20px;
        }
      }
    }


    ::v-deep .add {
      .el-form-item__label {
        font-weight: 700;
      }

      width: 100%;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }

          .yang {
            .el-form-item {
              .el-form-item__error {
                left: 40px;
              }

              margin-bottom: 5px;

              .el-form-item__label {
                // width: 150px !important;
                /*color: #060606;*/
              }

            }

          }

          .repair {
            .el-input {
              width: 80%;
            }

            .el-form-item {
              .el-form-item__error {
                /*left: 41px;*/
                padding-top: 0px;
              }

              margin-bottom: 7px;

              .el-form-item__label {
                /*width: 155px  !important;*/
                /*color: #060606;*/
              }
            }

            .el-upload-list__item {
              width: 100px;
              height: 100px;
            }

            .el-upload--picture-card {
              width: 100px;
              height: 100px;
              line-height: 100px;
            }

            /*display: none;*/
            .imgUp {
              display: flex;
              flex-direction: column;

              .imgLength {
                display: flex;
                align-items: center;
                width: 100%;

                span {
                  margin-left: auto;
                  color: rgb(183, 183, 183);
                  font-size: 16px;
                }
              }
            }
          }

        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 13px;
        margin-top: 20px;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {

      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #FFFFFF;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
        overflow: auto;
        max-height: 75vh;
        color: #606266;
      }

      .el-form--inline .el-form-item {
        margin-bottom: 5px;
      }

    }

  }

  .tableContainer {
    margin: 10px 0 30px 0;
  }

  .exportButton {
    span {
      color: rgba(51, 136, 255, 1);
      font-size: 14px;

      &:hover {
        cursor: pointer;
      }
    }
  }
</style>
